import React, {  Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';

/* Dialogs */
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';

/* Actions */
import {
	getShippingAddresses,
	printRequestOrderDetails,
	saveOrderDetails,
	deleteOrderDetails,
	saveApproveReturnsList,
	approveReturn,
	createNewOrder,
	getFiles
} from '../../../redux/actions';

class ApproveReturnCreditRequest extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orderDetails: null,
			backupOrderDetails: null,
			pickingUpByAddress: null,
			selectAll: false,
			originalOrderPrice:'',
			genericDialogHeading: '',
			genericDialogText: '',
			modalButtons: '',

			showCancelOrderConfirmationOverlaydialog: false,
			showSuccessfullyCancelledOverlayDialog: false,
			filesInS3:'',
			fileForCurrSerial:[],
			showNoFile: false
		}
		this.handleDialog = this.handleDialog.bind(this);
		this.updateStateWithOrderDetails = this.updateStateWithOrderDetails.bind(this);
		this.handleOpenFiles = this.handleOpenFiles.bind(this);
	}

	componentWillMount() {
		const self = this,
			accountNumber = self.props.getSelectedAccountNumber();
		if(self.props.state.order.orderDetails && accountNumber) {
			self.updateStateWithOrderDetails(self.props.state.order.orderDetails);
		} else {
			browserHistory.push('/approvereturns');
		}
	}

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleCancelReturn(event) {
		event.preventDefault();
		const self = this;
		self.setState({
			genericDialogHeading: 'Cancel Return',
			genericDialogText: 'Are you sure you want to cancel this return request?',
			modalButtons: 'yes,no'
		}, () => {
			self.handleDialog('CancelOrderConfirmationOverlaydialog', true, event);
		});
	}

	handleApproveReturn(event) {
		event.preventDefault();
		const self = this;
		const { typeOfUser } = self.props.state.user.userDetails;
		const creditOrderDetails = self.props.state.order.orderDetails.responseObject;
		const rebillOrderDetails = self.props.state.order.orderDetails.responseObject.rebillOrderDetails;
		self.setState({
			isCreditOrderCallCompleted: false,
			isRebillOrderCallCompleted: rebillOrderDetails ? false : true,
		}, () => {
			const salesRepNum = self.props.state.user.userDetails.isNonGEASsoUser && self.props.state.user.userDetails.isManRepSsoUser ? self.props.getASMAndDSASMSSOList() : undefined;
			self.props.approveReturn({
				...creditOrderDetails,
				userType: typeOfUser,
				salesRepNum
			}, 'requestType=approveReturn', response => {
				if(!response.status || !response.responseObject) {
					self.setState({
						errorMessage: 'Error occured while approving return'
					});
				} else {
					self.props.createNewOrder(null, "requestType=requestReturn&requestType=approveDBReturn&referenceNumber="+self.props.state.order.orderDetails.responseObject.referenceNumber, false, resp => {
						if(resp.status && resp.responseObject) {
							self.setState({
								isCreditOrderCallCompleted: true
							}, () => {
								self.callbackAfterParallelCall();
							});
						} else {
							browserHistory.push("/error");
						}
					});
				}
			});
			rebillOrderDetails && self.props.approveReturn({
				...rebillOrderDetails,
				userType: typeOfUser,
				salesRepNum
			}, 'requestType=approveReturn', response => {
				if(!response.status || !response.responseObject) {
					self.setState({
						errorMessage: 'Error occured while approving return'
					});
				} else {
					self.props.createNewOrder(null, "requestType=requestReturn&requestType=approveDBReturn&referenceNumber="+self.props.state.order.orderDetails.responseObject.rebillOrderDetails.referenceNumber, false, resp => {
						if(resp.status && resp.responseObject) {
							self.setState({
								isRebillOrderCallCompleted: true
							}, () => {
								self.callbackAfterParallelCall();
							});
						} else {
							browserHistory.push("/error");
						}
					});
				}
			});
		})
	}

	callbackAfterParallelCall() {
		const self = this;
		const {
			isCreditOrderCallCompleted,
			isRebillOrderCallCompleted,
			selectedOrderNumber,
			selectedRebillOrderNumber,
		} = self.state;
		if (isCreditOrderCallCompleted && isRebillOrderCallCompleted) {
			let approveReturnsList = _.filter(self.props.state.order.approveReturnsList.responseObject, (itm) => {
				return itm.orderHeader.orderNumber !== selectedOrderNumber
			});
			if(selectedRebillOrderNumber) {
				approveReturnsList = _.filter(self.props.state.order.approveReturnsList.responseObject, (itm) => {
					return itm.orderHeader.orderNumber !== selectedRebillOrderNumber
				});
			}
			self.setState({
				genericDialogHeading: 'Approve Return',
				genericDialogText: 'Return has been successfully approved.',
				modalButtons: 'ok'
			}, () => {
				//Save manage order list into store
				self.props.saveApproveReturnsList(JSON.parse(JSON.stringify({
					...self.props.state.order.approveReturnsList,
					responseObject: approveReturnsList
				})));
				self.handleDialog('SuccessfullyCancelledOverlayDialog', true, null);
			});
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		const self = this;
		const { orderDetails, originalOrderDetails } = self.props.state.order;
		let prices = {};
		if(originalOrderDetails && originalOrderDetails.length > 0){
			originalOrderDetails.forEach(item=>{
				prices[item.item] = item.price;
			})
		}
		if(orderDetails) {
			self.setState({
				selectedOrderNumber: orderDetails.responseObject.orderNumber,
				originalOrderPrice : prices,
				selectedRebillOrderNumber: orderDetails.responseObject.rebillOrderDetails && orderDetails.responseObject.rebillOrderDetails.orderNumber,
			});
		} else {
			browserHistory.push('/approvereturns');
		}
	}

	updateStateWithOrderDetails(response) {
		var self = this;
		if(!response.status) {
			self.setState({
				errorMessage: response.responseMessage
			})
		} else {
			//Save backup for handle print service
			self.setState({
				backupOrderDetails: JSON.parse(JSON.stringify(response.responseObject))
			})

			//Make shipping service call to get picking up by address
			let zipCode = response.responseObject.shippingAddress.zip;
			if(zipCode) {
				self.props.getShippingAddresses(`zip=${zipCode.split('-')[0]}&accountNumber=${self.props.getSelectedAccountNumber()}`, true, (resp) => {
					if(!resp.status) {
						self.setState({
							errorMessage: resp.responseMessage
						})
					} else {
						self.setState({
							pickingUpByAddress: _.find(resp.responseObject, ["loctype", "return_loc"])
						})
					}
				})
			}

			//filter all products which cancelled.
			response.responseObject.items = _.filter(response.responseObject.items, (item) => {
				return item.lineStatus !== 'CANCELLED';
			});

			let typeOfOrder = 'credit';
			response.responseObject.items.map((item, index) => {
				let extendedPrice = null;
				if(item.price && item.quantity) {
					extendedPrice = parseInt(item.price, 10) * parseInt(item.quantity, 10);
				}
				item.shipSet = item.shipSet?item.shipSet:0
				item.extendedPrice = extendedPrice;
				if(item.item === 'RESTOCKING FEE') {
					typeOfOrder = 'return';
				}
				return null;
			})

			self.setState({
				orderDetails: response.responseObject,
				rebillOrderDetails: response.responseObject.rebillOrderDetails ? JSON.parse(JSON.stringify(response.responseObject.rebillOrderDetails)) : null,
				typeOfOrder
			});
		}
	}

	handlePrint(event) {
		event.preventDefault();
		var self = this;
		self.setState({
			errorMessage: ''
		})
		let payload = JSON.parse(JSON.stringify(self.state.backupOrderDetails));
		payload.billingAddress = {
			address1: self.state.pickingUpByAddress.dockname,
			address2: self.state.pickingUpByAddress.dockaddr,
			state: self.state.pickingUpByAddress.dockst,
			city: self.state.pickingUpByAddress.dockcity,
			zip: self.state.pickingUpByAddress.dockzip,
			phone: self.props.normalizePhoneNumber(self.state.pickingUpByAddress.dockphone)
		};
		self.props.printRequestOrderDetails(payload, (response) => {
			if(!response.status) {
				self.setState({
					errorMessage: response.responseMessage
				})
			} else {
				window.open(response.responseObject);
			}
		})
	}

	handleCancelYesConfirmation(event) {
		event && event.preventDefault();
		const self = this;
		self.handleDialog('CancelOrderConfirmationOverlaydialog', false, event);
		const { userDetails } = self.props.state.user;
		const creditOrderDetails = self.props.state.order.orderDetails.responseObject;
		const rebillOrderDetails = self.props.state.order.orderDetails.responseObject.rebillOrderDetails;
		self.setState({
			isCreditOrderCallCompleted: false,
			isRebillOrderCallCompleted: rebillOrderDetails ? false : true,
		}, () => {
			const creditOrderPayload = {
				...creditOrderDetails,
				createdById: userDetails.sso,
				createdBy: userDetails.firstName + " " + userDetails.lastName,
				email: userDetails.email,
			};
			self.props.deleteOrderDetails(creditOrderPayload, 'requestType=cancelOrder', true, (response) => {
				if(!response.status || !response.responseObject) {
					self.setState({
						errorMessage: 'Error occured while cancelling return'
					});
				} else {
					self.props.createNewOrder(null, "requestType=requestReturn&requestType=approveDBReturn&referenceNumber="+self.props.state.order.orderDetails.responseObject.referenceNumber, false, resp => {
						if(resp.status && resp.responseObject) {
							self.setState({
								isCreditOrderCallCompleted: true
							}, () => {
								self.callbackAfterCancelParallelCall();
							})
						} else {
							browserHistory.push("/error");
						}
					});
				}
			});
			if(rebillOrderDetails) {
				const rebillOrderPayload = {
					...rebillOrderDetails,
					createdById: userDetails.sso,
					createdBy: userDetails.firstName + " " + userDetails.lastName,
					email: userDetails.email,
				};
				self.props.deleteOrderDetails(rebillOrderPayload, 'requestType=cancelOrder', true, (response) => {
					if(!response.status || !response.responseObject) {
						self.setState({
							errorMessage: 'Error occured while cancelling return'
						});
					} else {
						self.props.createNewOrder(null, "requestType=requestReturn&requestType=approveDBReturn&referenceNumber="+self.props.state.order.orderDetails.responseObject.rebillOrderDetails.referenceNumber, false, resp => {
							if(resp.status && resp.responseObject) {
								self.setState({
									isRebillOrderCallCompleted: true
								}, () => {
									self.callbackAfterCancelParallelCall();
								})
							} else {
								browserHistory.push("/error");
							}
						});
					}
				});
			}
		});
	}

	callbackAfterCancelParallelCall() {
		const self = this;
		const {
			isCreditOrderCallCompleted,
			isRebillOrderCallCompleted,
			selectedOrderNumber,
			selectedRebillOrderNumber,
		} = self.state;
		if (isCreditOrderCallCompleted && isRebillOrderCallCompleted) {
			let approveReturnsList = _.filter(self.props.state.order.approveReturnsList.responseObject, (itm) => {
				return itm.orderHeader.orderNumber !== selectedOrderNumber
			});
			if (selectedRebillOrderNumber) {
				approveReturnsList = _.filter(self.props.state.order.approveReturnsList.responseObject, (itm) => {
					return itm.orderHeader.orderNumber !== selectedRebillOrderNumber
				});
			}
			self.setState({
				genericDialogHeading: 'Cancel Return',
				genericDialogText: 'Return has been successfully cancelled.',
				modalButtons: 'ok'
			}, () => {
				//Save manage order list into store
				self.props.saveApproveReturnsList(JSON.parse(JSON.stringify({
					...self.props.state.order.approveReturnsList,
					responseObject: approveReturnsList
				})));
				self.handleDialog('SuccessfullyCancelledOverlayDialog', true, null);
			});
		}
	}

	handleSuccessfullyDelete(dialog, flag, event) {
		event && event.preventDefault();
		const self = this;
		self.handleDialog(dialog, flag, null);
		browserHistory.push('/approvereturns');
	}

	handleOpenFiles (accountNumber, originalOrderNumber, productNumber, serial, typeOfOrder) {
		const self = this;
		let serialNo = serial.split('-')[0];
		if(self.state.filesInS3.length === 0) {
			self.props.getFiles(`name=CustomerNet/ReturnAndCredit/${typeOfOrder === 'credit'? 'Credits':'Returns'}/${accountNumber}/${originalOrderNumber}/`,response => {
				if(response && response.responseObject && response.status && Object.keys(response.responseObject).length !== 0) {
						const fileAndUrl = [];
						serialNo.split(" ").map((ser)=>{
							const str = ser.includes('-') ? ser.split('-')[0]:ser;
							str !== "NA" && response && response.responseObject[str] && response.responseObject[str].length > 0 ? response.responseObject[str].map((item, index) => {
							const filename = originalOrderNumber+'-'+productNumber+'-'+str+'-'+(index+1);
							fileAndUrl.push({ [filename]: item});
							
						}) : self.setState({
							showNoFile: true
						});
					});
						self.setState({
							filesInS3 : response.responseObject,
							fileForCurrSerial : fileAndUrl,
						});
				} else {
					self.setState({
						showNoFile: true
					})
				}
			});
		} else {
			const fileAndUrl = [];
			serialNo.split(" ").map((ser)=>{
			self.state.filesInS3[ser].length > 0 ? self.state.filesInS3[ser].map((item, index) => {
				const filename = originalOrderNumber+'-'+productNumber+'-'+ser+'-'+(index+1);
				fileAndUrl.push({ [filename]: item});
				
			}) : self.setState({
				fileForCurrSerial: [],
				showNoFile: true
			});
		});
			self.setState({
				fileForCurrSerial : fileAndUrl,
				showNoFile: false
			});
		}
		
	}


	getReturnDetails(orderNumber, lineId) {
		const self = this;
		const { approveReturnsList, returnTypeDropdownValues, creditTypeDropdownValues } = self.props.state.order;
		let data = {};
		if(approveReturnsList && approveReturnsList.responseObject && approveReturnsList.responseObject.length) {
			const orderListData = approveReturnsList.responseObject.find(itm => itm.orderHeader.orderNumber === orderNumber);
			if(orderListData) {
				const record = orderListData.orderDetail.orderLine.find(itm => itm.orderLineId.toString() === lineId);
				if(record && record.returnReason) {
					if (self.state.typeOfOrder === 'return') {
						returnTypeDropdownValues.forEach(item => {
							const returnData = item.values.find(itm => itm.value === record.returnReason);
							if(returnData) {
								data = {
									reasonCategory: item.label,
									returnReason: returnData.label,
								}
							}
						});
					} else {
						const dropdownValues = window.convertToArrayOfObject(creditTypeDropdownValues, 'groupBy');
						dropdownValues.forEach(item => {
							const returnData = item.list.find(itm => itm.value === record.returnReason);
							if(returnData) {
								data = {
									reasonCategory: item.key,
									returnReason: returnData.label,
								}
							}
						});
					}
				}
			}
		}
		return data;
	}

	handleReturnToPreviousPage(e) {
			e.preventDefault();
			const self = this;
			browserHistory.push('/approvereturns');

		}
		
    render() {
		const self = this;
		const { orderDetails, pickingUpByAddress, typeOfOrder, rebillOrderDetails } = self.state;
		const isRestocking = orderDetails && orderDetails.items.filter(item => (item.item === 'RESTOCKING FEE' && item.lineType === 'Other Credit')).length > 0? true : false;
        return (
			<div>
				<p className="textRight d-none d-sm-block">
					<a className="withIcon withPrintIcon noUnderline bold uppercase" onClick={this.handlePrint.bind(this)} href="">Print Return Request Details</a>
				</p>
				<div className="d-none d-sm-block">
					<h1 className="pageTitle">Approve Return/Credit Request</h1>
				</div>
				<div className="d-block d-sm-none push m-3">
					<h1 className="pageTitle">Approve Return/Credit Request</h1>
				</div>
				<div className='d-none d-sm-block'>
					<h2>Request # {orderDetails && orderDetails.orderNumber}</h2>
					<p><b>Account #: {orderDetails && orderDetails.accountNumber}</b></p>
				</div>
				<div className='d-block d-sm-none m-3'>
					<h2>Request # {orderDetails && orderDetails.orderNumber}</h2>
					<p className='orderReviewColumns'><b>Account #:</b><br/> {orderDetails && orderDetails.accountNumber}</p>
				</div>
				<p className="bold red">{this.state.errorMessage}</p>
				{orderDetails && <div className='d-none d-sm-block'>
					<div>
						{typeOfOrder === 'return' &&
							<div className="orderReviewColumns columns threeColumns">
								<div className="orderReviewColumn column column2">
									<p>
										<strong>
											{orderDetails.deliveryMethod === "SDS Delivery"
												?"Picking Up from:"
												:(orderDetails.deliveryMethod === "SDS Will Call"
													?"Return From:"
													:null
												)
											}
										</strong><br />
										{orderDetails.shippingAddress.addressName && <span>{orderDetails.shippingAddress.addressName}<br /></span>}
										<span>{orderDetails.shippingAddress.address1}<br /></span>
										{orderDetails.shippingAddress.address2 && <span>{orderDetails.shippingAddress.address2}<br /></span>}
										<span>{orderDetails.shippingAddress.city + ', ' + orderDetails.shippingAddress.state + ' ' + orderDetails.shippingAddress.zip}<br /></span>
										{orderDetails.shippingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.shippingAddress.phone)}<br /></span>}
									</p>
								</div>
								<div className="orderReviewColumn column column3">
									{pickingUpByAddress && <p>
										<strong>
											{orderDetails.deliveryMethod === "SDS Delivery"
												?"Picking Up by:"
												:(orderDetails.deliveryMethod === "SDS Will Call"
													?"Return To:"
													:null
												)
											}
										</strong><br />
										{pickingUpByAddress.dockname && <span>{pickingUpByAddress.dockname}<br /></span>}
										<span>{pickingUpByAddress.dockaddr}<br /></span>
										<span>{pickingUpByAddress.dockcity + ', ' + pickingUpByAddress.dockst + ' ' + pickingUpByAddress.dockzip}<br /></span>
										{pickingUpByAddress.dockphone && <span>{this.props.normalizePhoneNumber(pickingUpByAddress.dockphone)}<br /></span>}
									</p>}
								</div>
							</div>
						}
						{typeOfOrder === 'credit' &&
							<div className="orderReviewColumns columns threeColumns">
								<div className="orderReviewColumn column column2">
									{orderDetails.billingAddress && <p>
										<strong>Billing Address</strong>:<br />
										{orderDetails.billingAddress.addressName && <span>{orderDetails.billingAddress.addressName}<br /></span>}
										<span>{orderDetails.billingAddress.address1}<br /></span>
										{orderDetails.billingAddress.address2 && <span>{orderDetails.billingAddress.address2}<br /></span>}
										<span>{orderDetails.billingAddress.city + ', ' + orderDetails.billingAddress.state + ' ' + orderDetails.billingAddress.zip}<br /></span>
										{orderDetails.billingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.billingAddress.phone)}<br /></span>}
									</p>}
								</div>
								<div className="orderReviewColumn column column3">
									{orderDetails.shippingAddress && <p>
										<strong>Shipping Address</strong>:<br />
										{orderDetails.shippingAddress.addressName && <span>{orderDetails.shippingAddress.addressName}<br /></span>}
										<span>{orderDetails.shippingAddress.address1}<br /></span>
										{orderDetails.shippingAddress.address2 && <span>{orderDetails.shippingAddress.address2}<br /></span>}
										<span>{orderDetails.shippingAddress.city + ', ' + orderDetails.shippingAddress.state + ' ' + orderDetails.shippingAddress.zip}<br /></span>
										{orderDetails.shippingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.shippingAddress.phone)}<br /></span>}
									</p>}
								</div>
							</div>
						}
					</div>
					<div className="orderReviewColumns columns threeColumns">
						<div className="orderReviewColumn column column2">
							<p>
								<strong>Request Entered By:</strong> {orderDetails.createdBy}<br />
								<strong>Request Entered On:</strong> {this.props.formatDate(orderDetails.orderDate, 'MM/DD/YY')}<br />
							</p>
						</div>
						<div className="orderReviewColumn column column3">
							<p>
								{orderDetails.deliveryInstructions && (orderDetails.deliveryInstructions.indexOf('RebillOrderRef') === -1 && orderDetails.deliveryInstructions.indexOf('CreditOrderRef') === -1) && <span><strong>Instructions:</strong>  {orderDetails.deliveryInstructions}<br /></span>}
							</p>
						</div>
					</div>
					<div className="push">
						<h2>Original CSO (Order number): {orderDetails.originalOrderNumber}</h2>
						<table className="reviewReturnTable dataTableType2 noRowBorders" style={{borderBottom: '1px solid #555'}}>
							<thead>
								<tr className="viperDarkHeader">
									<th className="product">Product</th>
									<th className="quantityToReturn" style={{textAlign: 'center'}}>Qty</th>
									<th className="originalInvoiceNumber" style={{textAlign: 'center'}}>Original<br />Invoice #</th>
									<th className="originalInvoiceNumber" style={{textAlign: 'center'}}>Original<br />Invoice Date</th>
									<th className="returnType">Return or Credit Type</th>
									<th className="reasonForReturn">Reason</th>
									<th className="serialNumber">Serial Number</th>
									<th className="credit">View Photo(s)</th>
									{typeOfOrder === 'return' && <th className="replacementRequested">Replacement Requested</th>}
									{typeOfOrder === 'return' && <th className="restockingFee">Price</th>}
									{typeOfOrder === "credit" && <th className="replacementRequested">Original Price</th>}
									{typeOfOrder === "credit" && <th className="restockingFee">Credit Amount</th>}
								</tr>
							</thead>
							<tbody>
								{orderDetails.items.map((item, index) => {
									const returnData = self.getReturnDetails(orderDetails.orderNumber, item.lineId);
									return <tr key={index}>
										<td className="product">{item.item}</td>
										<td className="quantityToReturn" style={{textAlign: 'center'}}>{item.quantity}</td>
										<td className="originalInvoiceNumber" style={{textAlign: 'center'}}>{item.originalInvoiceNumber}</td>
										<td className="originalInvoiceNumber" style={{textAlign: 'center'}}>{item.invoiceDate}</td>
										<td className="returnType">{returnData && returnData.reasonCategory}</td>
										<td className="reasonForReturn">{returnData && returnData.returnReason}</td>
										<td className="serialNumber">{item.userItemDescription}</td>
										<td className="credit">{ 
										returnData.returnReason ? 
											!returnData.returnReason.startsWith("Damaged") && typeOfOrder === 'return' ?
											'' : 
											(item.returnReason === "CREDIT ONLY - Push/Pull"?
											'':
											<input key={index} style={{  textDecoration:"underline", color:"#0d6efd", border:'none' }} 
											value='Open Photo(s)' onClick={() => this.handleOpenFiles(orderDetails.accountNumber, orderDetails.originalOrderNumber, item.item, item.userItemDescription.split('-')[0], typeOfOrder)}/> )
											: null}
										</td>
										{typeOfOrder === 'return' && <td className="replacementRequested">{item.replacementNeeded ? "Yes" : "No"}</td>}
										{typeOfOrder === 'return' && <td className="restockingFee">
											{item.price ? self.props.formatMoney(item.price, 0, ".", ",", false, "$") : '$0.00'}
										</td>}
										{typeOfOrder === 'credit' && <td className="replacementRequested">{self.props.formatMoney(self.state.originalOrderPrice[item.item], 0, ".", ",", false, "$")}</td>}
										{typeOfOrder === 'credit' && <td className="restockingFee">
											{item.price ? self.props.formatMoney(Number(item.price).toFixed(2), 0, ".", ",", false, "-$") : '$0.00'}
										</td>}
									</tr>
								})}
							</tbody>
			      		</table>
						{rebillOrderDetails && <div>
							<h2>Rebill CSO: {rebillOrderDetails.orderNumber}</h2>
							<table className="reviewReturnTable dataTableType2 noRowBorders" style={{borderBottom: '1px solid #555'}}>
								<thead>
									<tr className="viperDarkHeader">
										<th>Product</th>
										<th>Qty</th>
										<th>Account</th>
										<th>Sales Agreement</th>
										<th>Price</th>
									</tr>
								</thead>
								<tbody>
									{rebillOrderDetails.items.map((item, index) => {
										return <tr key={index}>
											<td>{item.item}</td>
											<td>{item.quantity}</td>
											<td>{rebillOrderDetails.accountNumber}</td>
											<td>{item.agreementName}</td>
											<td>{self.props.formatMoney(item.price, 0, ".", ",", false, "$")}</td>
										</tr>
									})}
								</tbody>
				      		</table>
						</div>}
						{ isRestocking ? <div className="push" style={{ textAlign: 'right' }}>
				 			<p className="bold red" style={{ marginTop: '1px' }}>All Restocking that is credited will be billed to the Region.</p>
						</div> : null}
						{self.state.showNoFile ? <p className="bold red">No FIles </p>: ''}
						{self.state.fileForCurrSerial.length > 0 ? self.state.fileForCurrSerial.map((fileObj, index) => {
        					const filename = Object.keys(fileObj)[0];
        					const item = fileObj[filename];
							return (
							<div key={index}>
								<a href={item} target="_blank">
								{filename}
								</a>
							</div>
							);
      					}): ''}
						<div className="actionBar">
						<p className="textLeft" style={{margin:"0"}}><a href="" onClick={this.handleReturnToPreviousPage.bind(this)}>Return to Previous Screen</a></p>
						<p className="textRight" style={{margin:"0"}}>
							<a className="blueButton" href="" onClick={this.handleCancelReturn.bind(this)}>Cancel</a>
							<a className="blueButton" href="" onClick={this.handleApproveReturn.bind(this)} style={{marginLeft: '1rem'}}>Approve</a>
						</p>
						</div>
					</div>
				</div>}
				{orderDetails && <div className='d-block d-sm-none m-3'>
					<div>
						{typeOfOrder === 'return' &&
							<div className="orderReviewColumns">
								<div className="orderReviewColumn">
									<p>
										<strong>
											{orderDetails.deliveryMethod === "SDS Delivery"
												?"Picking Up from:"
												:(orderDetails.deliveryMethod === "SDS Will Call"
													?"Return From:"
													:null
												)
											}
										</strong><br />
										{orderDetails.shippingAddress.addressName && <span>{orderDetails.shippingAddress.addressName}<br /></span>}
										<span>{orderDetails.shippingAddress.address1}<br /></span>
										{orderDetails.shippingAddress.address2 && <span>{orderDetails.shippingAddress.address2}<br /></span>}
										<span>{orderDetails.shippingAddress.city + ', ' + orderDetails.shippingAddress.state + ' ' + orderDetails.shippingAddress.zip}<br /></span>
										{orderDetails.shippingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.shippingAddress.phone)}<br /></span>}
									</p>
								</div>
								<div className="orderReviewColumn">
									{pickingUpByAddress && <p>
										<strong>
											{orderDetails.deliveryMethod === "SDS Delivery"
												?"Picking Up by:"
												:(orderDetails.deliveryMethod === "SDS Will Call"
													?"Return To:"
													:null
												)
											}
										</strong><br />
										{pickingUpByAddress.dockname && <span>{pickingUpByAddress.dockname}<br /></span>}
										<span>{pickingUpByAddress.dockaddr}<br /></span>
										<span>{pickingUpByAddress.dockcity + ', ' + pickingUpByAddress.dockst + ' ' + pickingUpByAddress.dockzip}<br /></span>
										{pickingUpByAddress.dockphone && <span>{this.props.normalizePhoneNumber(pickingUpByAddress.dockphone)}<br /></span>}
									</p>}
								</div>
							</div>
						}
						{typeOfOrder === 'credit' &&
							<div className="orderReviewColumns">
								<div className="orderReviewColumn">
									{orderDetails.billingAddress && <p>
										<strong>Billing Address</strong>:<br />
										{orderDetails.billingAddress.addressName && <span>{orderDetails.billingAddress.addressName}<br /></span>}
										<span>{orderDetails.billingAddress.address1}<br /></span>
										{orderDetails.billingAddress.address2 && <span>{orderDetails.billingAddress.address2}<br /></span>}
										<span>{orderDetails.billingAddress.city + ', ' + orderDetails.billingAddress.state + ' ' + orderDetails.billingAddress.zip}<br /></span>
										{orderDetails.billingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.billingAddress.phone)}<br /></span>}
									</p>}
								</div>
								<div className="orderReviewColumn">
									{orderDetails.shippingAddress && <p>
										<strong>Shipping Address</strong>:<br />
										{orderDetails.shippingAddress.addressName && <span>{orderDetails.shippingAddress.addressName}<br /></span>}
										<span>{orderDetails.shippingAddress.address1}<br /></span>
										{orderDetails.shippingAddress.address2 && <span>{orderDetails.shippingAddress.address2}<br /></span>}
										<span>{orderDetails.shippingAddress.city + ', ' + orderDetails.shippingAddress.state + ' ' + orderDetails.shippingAddress.zip}<br /></span>
										{orderDetails.shippingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.shippingAddress.phone)}<br /></span>}
									</p>}
								</div>
							</div>
						}
					</div>
					<div className="orderReviewColumns">
						<div className="orderReviewColumn">
							<p>
								<strong>Request Entered By:</strong><br/> {orderDetails.createdBy}<br />
								<strong>Request Entered On:</strong><br/> {this.props.formatDate(orderDetails.orderDate, 'MM/DD/YY')}<br />
							</p>
						</div>
						<div className="orderReviewColumn">
							<p>
								{orderDetails.deliveryInstructions && (orderDetails.deliveryInstructions.indexOf('RebillOrderRef') === -1 && orderDetails.deliveryInstructions.indexOf('CreditOrderRef') === -1) && <span><strong>Instructions:</strong> <br/> {orderDetails.deliveryInstructions}<br /></span>}
							</p>
						</div>
					</div>
					<button className='d-block d-sm-none p-2' style={{width: "100%", textAlign:"left"}}>
						<a className="noUnderline bold uppercase p-2" style={{color:"#fff", paddingTop:"1rem", fontSize:"14px"}} onClick={this.handlePrint.bind(this)} href="">Print Return Request Details</a>
					</button>
					<div className="push">
					<div className="captionAboveTable">
						<div>
						<div className="bold">{`ORIGINAL CSO (ORDER NUMBER) : `}{orderDetails.originalOrderNumber}</div>
						</div>
					</div>
						{orderDetails.items.map((item, index) => {
							const returnData = self.getReturnDetails(orderDetails.orderNumber, item.lineId);
							return <div className="accordion accordion-borderless" id={`accordionApproveReturnCreditRequest${index}`}  key={index}>
								<div>
								<h2 className="accordion-header" id={`flush-ApproveReturnCreditRequest${index}`}>
								<button className="accordion-button mobileAccButton" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseApproveReturnCreditRequest${index}`} aria-expanded="true" aria-controls={`flush-collapseApproveReturnCreditRequest${index}`}>
										{`ITEM `} {item.item}<br/>
									</button>
									</h2>
									<div id={`flush-collapseApproveReturnCreditRequest${index}`} className="accordion-collapse collapse show" aria-labelledby={`flush-ApproveReturnCreditRequest${index}`} data-bs-parent={`#accordionApproveReturnCreditRequest${index}`}>
									<table className='orderTable'>
										<tbody>
											<tr className='border-bottom'>
												<td className='p-3 fw-bold'>QUANTITY </td>
												<td className="quantityToReturn"><span>{item.quantity}</span></td>
											</tr>
											<tr className=''>
												<td className='p-3 fw-bold'>SERIAL NUMBER(S)</td>
												<td>{``}</td>
											</tr>
											<tr className='border-bottom'>
												<td className='p-3'>{item.userItemDescription}</td>
												<td className="credit">{ 
													returnData.returnReason ? 
														!returnData.returnReason.startsWith("Damaged") && typeOfOrder === 'return' ?
														'' : <input key={index} 
														style={{ border:"none",textDecoration:"underline", color:"#0d6efd" }} 
														value='Open Photo(s)' onClick={() => this.handleOpenFiles(orderDetails.accountNumber, orderDetails.originalOrderNumber, item.item, item.userItemDescription.split('-')[0], typeOfOrder)}/> : null}
												</td>
											</tr>
											<tr className='border-bottom'>
												<td className='p-3 fw-bold'>ORIGINAL INVOICE #</td>
												<td className="originalInvoiceNumber">{item.originalInvoiceNumber}</td>
											</tr>
											<tr className='border-bottom'>
												<td className='p-3 fw-bold'>ORIGINAL INVOICE DATE</td>
												<td className="originalInvoiceNumber">{item.invoiceDate}</td>
											</tr>
											<tr className='border-bottom'>
												<td className='p-3 fw-bold'>RETURN OR CREDIT TYPE</td>
												<td className="returnType">{returnData && returnData.reasonCategory}</td>
											</tr>
											<tr className='border-bottom'>
												<td className='p-3 fw-bold'>REASON</td>
												<td className="reasonForReturn">{returnData && returnData.returnReason}</td>
											</tr>
											<tr className='border-bottom'>
											{typeOfOrder === 'return' && <td className='p-3 fw-bold'>REPLACEMENT REQUESTED</td>}
											{typeOfOrder === 'credit' && <td className='p-3 fw-bold'>ORIGINAL PRICE</td>}
												{typeOfOrder === 'return' && <td className="replacementRequested">{item.replacementNeeded ? "Yes" : "No"}</td>}
												{typeOfOrder === 'credit' && <td className="replacementRequested">{self.props.formatMoney(self.state.originalOrderPrice[item.item], 0, ".", ",", false, "$")}</td>}
											</tr>
											<tr>
												<td className='p-3 fw-bold'>PRICE</td>
												{typeOfOrder === 'return' && <td className="restockingFee">
													{item.price ? self.props.formatMoney(item.price, 0, ".", ",", false, "$") : '$0.00'}
												</td>}
												{typeOfOrder === 'credit' && <td className="restockingFee">
													{item.price ? self.props.formatMoney(Number(item.price).toFixed(2), 0, ".", ",", false, "-$") : '$0.00'}
												</td>}
											</tr>
										</tbody>
									</table>
								</div>
								</div>
							</div>
								})}
						{rebillOrderDetails && <div>
							<h2>Rebill CSO: {rebillOrderDetails.orderNumber}</h2>
							<table className="reviewReturnTable dataTableType2 noRowBorders" style={{borderBottom: '1px solid #555'}}>
								<thead>
									<tr className="viperDarkHeader">
										<th>Product</th>
										<th>Qty</th>
										<th>Account</th>
										<th>Sales Agreement</th>
										<th>Price</th>
									</tr>
								</thead>
								<tbody>
									{rebillOrderDetails.items.map((item, index) => {
										return <tr key={index}>
											<td>{item.item}</td>
											<td>{item.quantity}</td>
											<td>{rebillOrderDetails.accountNumber}</td>
											<td>{item.agreementName}</td>
											<td>{self.props.formatMoney(item.price, 0, ".", ",", false, "$")}</td>
										</tr>
									})}
								</tbody>
				      		</table>
						</div>}
						{ isRestocking ? <div className="push" style={{ textAlign: 'right' }}>
				 			<p className="bold red" style={{ marginTop: '1px' }}>All Restocking that is credited will be billed to the Region.</p>
						</div> : null}
						{self.state.showNoFile ? <p className="bold red">No FIles </p>: ''}
						{self.state.fileForCurrSerial.length > 0 ? self.state.fileForCurrSerial.map((fileObj, index) => {
        					const filename = Object.keys(fileObj)[0];
        					const item = fileObj[filename];
							return (
							<div key={index}>
								<a href={item} target="_blank">
								{filename}
								</a>
							</div>
							);
      					}): ''}
						<p className="textRight">
							<a className="blueButton p-2" style={{fontSize:"10px"}} href="" onClick={this.handleCancelReturn.bind(this)}>Cancel</a>
							<a className="blueButton p-2" style={{fontSize:"10px", marginLeft: '1rem'}} href="" onClick={this.handleApproveReturn.bind(this)}>Approve</a>
						</p>
					</div>
				</div>}
				{this.state.showCancelOrderConfirmationOverlaydialog?<GenericOverlayDialog flag={'CancelOrderConfirmationOverlaydialog'} handleYes={this.handleCancelYesConfirmation.bind(this)} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showSuccessfullyCancelledOverlayDialog?<GenericOverlayDialog flag={'SuccessfullyCancelledOverlayDialog'} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleSuccessfullyDelete.bind(this)} showDialog={true} />:null}
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	saveOrderDetails: (data) => dispatch(saveOrderDetails(data)),
	saveApproveReturnsList: (data) => dispatch(saveApproveReturnsList(data)),
	deleteOrderDetails: (payload, queryStringParams, showLoader, callback) => dispatch(deleteOrderDetails(payload, queryStringParams, showLoader, callback)),
	approveReturn: (payload, queryStringParams, callback) => dispatch(approveReturn(payload, queryStringParams, callback)),
	getShippingAddresses: (queryStringParams, showLoader, callback) => dispatch(getShippingAddresses(queryStringParams, showLoader, callback)),
	printRequestOrderDetails: (payload, callback) => dispatch(printRequestOrderDetails(payload, callback)),
	createNewOrder: (payload, params, useBootApi, response) => dispatch(createNewOrder(payload, params, useBootApi, response)),
	getFiles: (payload, callback) => dispatch(getFiles(payload, callback)),
});

ApproveReturnCreditRequest = connect(mapStateToProps, mapDispatchToProps)(ApproveReturnCreditRequest);
export default ApproveReturnCreditRequest;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/approveReturnCreditRequest.js